module.exports = __webpack_public_path__ + "img/2375a9f.jpg";